import {
  HttpEventType,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { filter, of, switchMap } from 'rxjs';
import { addQueryParams } from '../constants/app.constants';

export const archivalRetryInterceptor: HttpInterceptorFn = (req, next) => {
  if (isGetCustomerRecoveryCaseListApiCall(req)) {
    return next(req).pipe(
      filter((event) => event.type === HttpEventType.Response),
      switchMap((response) => {
        const result = response as any;
        const noResponseFound =
          !result?.body?.customerRecoveryDetails ||
          result?.body?.customerRecoveryDetails?.length == 0;
        return noResponseFound
          ? next(
              req.clone({ url: addQueryParams(req.url, 'useArchive', 'true') })
            )
          : of(response);
      })
    );
  }

  if (isGetCustomerRecoveryCaseCountApiCall(req)) {
    return next(req).pipe(
      filter((event) => event.type === HttpEventType.Response),
      switchMap((response) => {
        const noResponseFound = response?.body == 0;
        return noResponseFound
          ? next(
              req.clone({ url: addQueryParams(req.url, 'useArchive', 'true') })
            )
          : of(response);
      })
    );
  }

  return next(req);
};

const isGetCustomerRecoveryCaseListApiCall = (req: HttpRequest<unknown>) =>
  req.method.toUpperCase() == 'POST' &&
  req.url.includes('list') &&
  !req.url.includes('list-by-groupid') &&
  !req.url.includes('useArchive=true') &&
  req.url.includes('customer-recovery-claims');

const isGetCustomerRecoveryCaseCountApiCall = (req: HttpRequest<unknown>) =>
  req.method.toUpperCase() == 'POST' &&
  req.url.includes('customer-recovery-claims/count') &&
  !req.url.includes('useArchive=true');
